import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { FileInput } from "components/form/FileInput";
import { withVar } from "themes/helpers";

interface IProps {
  attachments: Attachment[];
  privateMode: boolean;
  onChange(index: number, file: File): void;
  onRemove(index: number): void;
}

export type Attachment = File | null;

interface IStyledContainer {
  displayed: boolean;
  privateMode: boolean;
}

const StyledContainer = styled.div<IStyledContainer>`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  border-radius: 4px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => withVar(props.privateMode ? DesignToken.ContentInvertPrimary : DesignToken.ContentBasicPrimary)
  };
  background: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => withVar(props.privateMode ? DesignToken.SurfaceInvertSecondary : DesignToken.SurfacePrimaryDefault)
  };
  font-size: 14px;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => !props.displayed && "display: none"
  };
`;

interface IStyledName {
  onClick(e: React.MouseEvent): void;
}

const StyledName = styled.span<IStyledName>`
  flex: 1;
  padding: 7px;
`;

interface IStyledRemoveLink {
  privateMode: boolean;
}

const StyledRemoveLink = styled.span<IStyledRemoveLink>`
  padding: 7px;
  cursor: pointer;
  margin-left: auto;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.privateMode &&
      `
color: ${withVar(DesignToken.ContentInvertSecondary)};
&:hover {
color: ${withVar(DesignToken.ContentInvertPrimary)};
}
`
  };
`;

export class TicketAttachments extends React.PureComponent<IProps> {
  private lastFileInputRef = React.createRef<HTMLDivElement>();
  // @ts-expect-error TS(2564): Property 'cleanupFn' has no initializer and is not... Remove this comment to see the full error message
  cleanupFn: () => void;
  private cleanupLock = false;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    this.activateLastFileInput();
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  componentDidUpdate(prevProps: any) {
    if (this.props.attachments.length > prevProps.attachments.length) {
      this.activateLastFileInput();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  private cleanupAttachmentsOnFocus = (oldAttachments: any[]) => () => {
    setTimeout(() => {
      if (!this.cleanupLock) {
        if (!oldAttachments.some((f, i) => f !== this.props.attachments[i])) {
          this.props.attachments.forEach((f, i) => {
            if (f === null) {
              this.props.onRemove(i);
            }
          });
        }
      }

      window.removeEventListener("focus", this.cleanupFn);
    }, 250);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private activateLastFileInput = () => {
    if (this.lastFileInputRef.current) {
      this.cleanupLock = false;
      // In case user clicks cancel we are left with null entries in attachments which blocks rich editor. This removes nulls in such case.
      this.cleanupFn = this.cleanupAttachmentsOnFocus([...this.props.attachments]);
      window.addEventListener("focus", this.cleanupFn);

      this.lastFileInputRef.current.click();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleSuppressClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleAttachmentChange = (index: number) => (file: File) => {
    this.cleanupLock = true;
    this.props.onChange(index, file);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleAttachmentRemove = (index: number) => (e: React.MouseEvent) => {
    this.handleSuppressClick(e);
    this.props.onRemove(index);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { attachments, privateMode } = this.props;

    return attachments.map((attachment: Attachment, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <FileInput key={index} onChange={this.handleAttachmentChange(index)}>
        <StyledContainer privateMode={privateMode} displayed={attachment instanceof File} ref={this.lastFileInputRef}>
          {attachment && <StyledName onClick={this.handleSuppressClick}>{attachment.name}</StyledName>}
          <StyledRemoveLink privateMode={privateMode} onClick={this.handleAttachmentRemove(index)}>
            remove
          </StyledRemoveLink>
        </StyledContainer>
      </FileInput>
    ));
  }
}
